import React, { Component } from 'react';
import { Popover, OverlayTrigger } from "react-bootstrap";
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'qrcode.react';

import { ConsultInscripcionInd, GenerarConstanciaInd } from '../../../funciones/ConstanciaFunction';
import { ConsultaDeudaEst } from '../../../funciones/EstCuentaFunction';
import { SvgToPng } from "../../../funciones/AdmisionFunction";

import ModalReports from '../../../components/Reportes/ModalReports';
import ConstanciaEst from '../../../components/Reportes/ConstanciaEst';
import MensajeRetrasoInd from "../../../shared/MensajeRetrasoInd";

let statusBtn = 0;
let token = "";
let fecha = "";
let deudaTSolic = "";

class EstudiantesConstanciaTable extends Component {
    state = {
        button: {
            icon: "fa fa-file-text",
            text: "Imprimir"
        },
        status: {
            icon: "fa fa-spinner fa-spin",
            text: "Verificando, espera por favor",
            class: "custom-alert-info",
            styles:{fontSize:12, position:"absolute", top: 4}
        },
        constancias: [],
        datosEst:"",
        openW:false,
        qr: "",
    }

    constructor (props) {
        super (props);
        ConsultInscripcionInd (this.props.data.id_estudiante, (resp) => {
            statusBtn = resp[3]
            this.setState({
                status: resp[0],
                constancias: resp[1],
                datosEst: resp[2]
            })
        })
    }

    componentDidMount = () => {
        ConsultaDeudaEst (this.props.data.id_estudiante, (resp) => {
            deudaTSolic = resp.deudaVencida
            this.setState({deudaT: resp.deudaVencida})
        })
    }

    procesaConstancia = () => {
        /* let imgSvg = (
            <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${token.substring(0,10)}`}/>
        )

        const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
        const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;

        SvgToPng (dataUri, (qr) => {
            this.setState({ qr: qr })
        }) */
        this.setState({
            button: {
                icon: "fa fa-spinner fa-spin",
                text: "Imprimir"
            }
        }, () => {
            GenerarConstanciaInd(this.props.data.id_estudiante, (resp) => {
                let data = JSON.parse(resp)
                token = data.token
                fecha = data.fecha
                this.setState({
                    button: {
                        icon: "fa fa-file-text",
                        text: "Imprimir"
                    },
                    openW:true
                }, () => {
                    ConsultInscripcionInd (this.props.data.id_estudiante, (resp) => {
                        statusBtn = resp[3]
                        this.setState({
                            status: resp[0],
                            constancias: resp[1],
                        })
                    })
                })
            })
        })
    }

    modal = () => {
        if (this.state.openW === false) return null

        return (
            <ModalReports
                reporte={<ConstanciaEst
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                    qr = {this.state.qr}
                />}
                titulo="Impresión de Constancia de Estudios (Simple)"
                display= "block"
                cerrar = {() => {this.setState({openW:false})}}
                />
        )
    }

    botones = () => {
        let { button } = this.state;
        switch (statusBtn) {
            case 0:
                if (deudaTSolic > 0) {
                    let contenidoD = () => (
                        <Popover bsSize="large" id="Inscrito">
                            <MensajeRetrasoInd />
                        </Popover>
                    )
                    
                    return (
                        <OverlayTrigger ref="overlay" trigger="focus" placement="right" overlay={contenidoD()}>
                            <button className="btn btn-primary" style={{borderWidth: 1}}><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    )
                }

                return (
                    <button className="btn btn-primary" onClick = {this.procesaConstancia} style={{borderWidth: 1}}><i className={button.icon}></i> {button.text}</button>
                )
            case 1:
                    let contenido = (
                        <Popover bsSize="large" id="Inscrito">
                            <div className="custom-alert-danger" align="center">Estudiante no inscrito</div>
                            <div align="justify" className="custom-mt-10">
                                Este estudiante no ha formalizado su inscripción
                            </div>
                        </Popover>
                    )
    
                    return (
                        <div className="btn-group" role="group">
                            <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                                <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                            </OverlayTrigger>
                        </div>
                    )
            case 2:
                let contenido2 = (
                    <Popover bsSize="large" id="Inscrito">
                        <div className="custom-alert-danger" align="center">Importante</div>
                        <div align="justify" className="custom-mt-10">
                            La inscripción de este estudiante aún no está aprobada.
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido2}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                }return (
                    <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-times" title="Presiona F5 para refrescar esta página"></i> Error al Cargar</button>
                )
    }

    render() { 
        const styles = {
            padding: 5, fontSize: 12
        }
        let nombre2 = this.props.data.nombre_2;
        let apellido2 = this.props.data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";
        let nombreCompleto = `${this.props.data.nombre_1} ${nombre2} ${this.props.data.apellido_1} ${apellido2}`

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles}>{`${this.props.data.nacionalidad} ${this.props.data.ci}`}</td>
                    <td style={styles}>{nombreCompleto}</td>
                    <td align="center" style={styles}>{this.props.data.carrera_name}</td>
                    <td align="center" style={styles}>
                        {this.botones()}
                    </td>
                </tr>
                {this.modal()}
            </React.Fragment>
            
        );
    }
}
 
export default EstudiantesConstanciaTable;


// WEBPACK FOOTER //
// ./src/views/Reportes/ConstanciaContent/EstudiantesConstanciaTable.jsx